import _ from 'lodash'; // eslint-disable-line
import { ActionTypes } from '../actions/formHistoryActions';

const initialState = {
  past: [],
  // present: null,
  // future: [],
};

function formChanges(state = initialState, action = {}) {
  switch (action.type) {
    case ActionTypes.PUSH_CHANGE: {
      const changeFunc = action.payload;
      return {
        ...state,
        past: [...state.past, changeFunc]
      };
    }
    case ActionTypes.POP_CHANGE: {
      const nextPast = _.dropRight(state.past);
      return {
        ...state,
        past: nextPast,
      };
    }
    case ActionTypes.CLEAR_HISTORY: {
      return {
        ...state,
        past: []
      };
    }
    default: {
      return { ...state };
    }
  }
}

export default formChanges;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/formHistory.js
 **/